import { TableHead } from '@/components/Datatable/TableHead';
import { useUserRole } from '@/hooks/auth.hooks';
import { SortableTableHeadersProps } from '@/type/listing.types';
import { twMerge } from 'tailwind-merge';

export const VehiculeCheckTableHeaders = ({
  t,
  onSort,
}: SortableTableHeadersProps) => {
  const { isModerator } = useUserRole();

  return (
    <>
      {/* <TableHead text="N°" sortable thClassName="min-w-0 w-0" /> */}
      <TableHead
        text={t('common:referenceNumber_short')}
        thClassName={twMerge(
          'min-w-[170px] max-[1512px]:min-w-[155px]',
          !isModerator && '!px-2.5'
        )}
      />
      {/* <TableHead text="Date" sortable thClassName="min-w-[195px]" /> */}
      <TableHead
        text={t('common:date')}
        thClassName="w-[140px] max-[1512px]:w-[137px]"
        sortable
        onSortClick={() => onSort?.('updatedAt')}
      />
      <TableHead
        text={`${t('common:licensePlateNumber')} & ${t('common:vin')}`}
        thClassName="w-[230px]"
        sortable
        onSortClick={() => onSort?.('licensePlateAndVin')}
      />
      <TableHead
        text={t('common:performedBy')}
        thClassName="text-center w-[220.75px]"
      />
      {/* <TableHead
        text="Nb élélements détectés"
        thClassName="text-center min-w-0 w-0"
      /> */}
      <TableHead
        text={t('common:moderation')}
        thClassName="!px-2.5 text-center w-[125px]"
      />
      <TableHead
        text={t('common:status')}
        thClassName="!px-2.5 text-center min-w-[150px]"
      />
      <TableHead thClassName="sticky-action-column" />
    </>
  );
};
